import api from './api';
import type { PagedResult } from '../types';
import type {
  CrmEmpresa,
  CrmEmpresaAsociarContactos,
  CrmEmpresaCreate,
  CrmEmpresaListItem,
  CrmEmpresaSearch,
  CrmEmpresaUpdate,
} from '../types/crm';

const crmEmpresaService = {
  getAll: async (params: CrmEmpresaSearch = {}): Promise<PagedResult<CrmEmpresaListItem>> => {
    const response = await api.get<PagedResult<CrmEmpresaListItem>>('/api/CrmEmpresas', {
      params: {
        pageNumber: 1,
        pageSize: 20,
        activo: true,
        ...params,
      },
    });
    return response.data;
  },

  getById: async (id: number): Promise<CrmEmpresa> => {
    const response = await api.get<CrmEmpresa>(`/api/CrmEmpresas/${id}`);
    return response.data;
  },

  create: async (dto: CrmEmpresaCreate): Promise<CrmEmpresa> => {
    const response = await api.post<CrmEmpresa>('/api/CrmEmpresas', dto);
    return response.data;
  },

  update: async (id: number, dto: CrmEmpresaUpdate): Promise<CrmEmpresa> => {
    const response = await api.put<CrmEmpresa>(`/api/CrmEmpresas/${id}`, dto);
    return response.data;
  },

  asociarContactos: async (id: number, dto: CrmEmpresaAsociarContactos): Promise<CrmEmpresa> => {
    const response = await api.post<CrmEmpresa>(`/api/CrmEmpresas/${id}/contactos`, dto);
    return response.data;
  },

  desasociarContacto: async (id: number, contactoId: number): Promise<CrmEmpresa> => {
    const response = await api.delete<CrmEmpresa>(`/api/CrmEmpresas/${id}/contactos/${contactoId}`);
    return response.data;
  },
};

export default crmEmpresaService;
